export const beneficiaryListTranslations = {
    en: {
        // Page Title
        preRegisteredUsers: "Pre-Registered Users",
        beneficiaryListFor: "Beneficiary List for",
        allCampaigns: "All Campaigns",

        // Table Headers
        name: "Name",
        tokenNo: "Token No",
        mobileNo: "Mobile No",
        email: "Email",
        village: "Village",
        status: "Status",
        actions: "Actions",
        adhaarNumber: "Adhaar Number",
        phone: "Phone",
        taluka: "Taluka",
        district: "District",
        dateRegistered: "Date Registered",
        action: "Action",

        // Status Filters
        preRegistered: "Pre-Registered",
        registered: "Registered",
        all: "All",

        // Buttons
        addBeneficiary: "Add Beneficiary",
        view: "View",
        viewProfile: "View Profile",
        updateStatus: "Update Status",

        // Search
        searchPlaceholder: "Search by name or OPD number...",

        // Empty States
        noBeneficiariesFound: "No Beneficiaries Found",
        noSearchResults: "No results match your search. Try a different name or OPD number.",
        noDataMessage: "Add a beneficiary or adjust the filter to view existing users.",

        // Common
        notAvailable: "N/A",
        unknown: "Unknown",
        noData: "--",

        // Dialog/Drawer Titles
        addBeneficiaryTitle: "Add Beneficiary",
        confirmTitle: "Confirm",

        // Module Name
        beneficiaryListModule: "Beneficiary List",
    },
    mr: {
        // Page Title
        preRegisteredUsers: "पूर्व-नोंदणीकृत वापरकर्ते",
        beneficiaryListFor: "लाभार्थी यादी",
        allCampaigns: "सर्व मोहिमा",

        // Table Headers
        name: "नाव",
        tokenNo: "टोकन क्रमांक",
        mobileNo: "मोबाइल क्रमांक",
        email: "ईमेल",
        village: "गाव",
        status: "स्थिती",
        actions: "क्रिया",
        adhaarNumber: "आधार क्रमांक",
        phone: "फोन",
        taluka: "तालुका",
        district: "जिल्हा",
        dateRegistered: "नोंदणी तारीख",
        action: "क्रिया",

        // Status Filters
        preRegistered: "पूर्व-नोंदणीकृत",
        registered: "नोंदणीकृत",
        all: "सर्व",

        // Buttons
        addBeneficiary: "लाभार्थी जोडा",
        view: "पहा",
        viewProfile: "प्रोफाइल पहा",
        updateStatus: "स्थिती अद्यतनित करा",

        // Search
        searchPlaceholder: "नाव किंवा OPD क्रमांकाद्वारे शोधा...",

        // Empty States
        noBeneficiariesFound: "लाभार्थी सापडले नाहीत",
        noSearchResults: "आपल्या शोधाशी कोणतेही परिणाम जुळत नाहीत. वेगळे नाव किंवा OPD क्रमांक प्रयत्न करा.",
        noDataMessage: "लाभार्थी जोडा किंवा विद्यमान वापरकर्ते पाहण्यासाठी फिल्टर समायोजित करा.",

        // Common
        notAvailable: "उपलब्ध नाही",
        unknown: "अज्ञात",
        noData: "--",

        // Dialog/Drawer Titles
        addBeneficiaryTitle: "लाभार्थी जोडा",
        confirmTitle: "पुष्टी करा",

        // Module Name
        beneficiaryListModule: "लाभार्थी यादी",
    }
};
